import { render, staticRenderFns } from "./ReviewPanel.vue?vue&type=template&id=f97fe7e4&scoped=true&"
import script from "./ReviewPanel.vue?vue&type=script&lang=js&"
export * from "./ReviewPanel.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPanel.vue?vue&type=style&index=0&id=f97fe7e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97fe7e4",
  null
  
)

export default component.exports